module.exports = __webpack_public_path__ + "static/Moody3-ead3914909ebf75d947a350b0fdb6009.png";